import type { JSX } from 'react';
import XSLogo from './assets/xs_logo_color.svg?react';
import { LogoBox } from './LogoBox.tsx';

export function OpenXSelectLogo(): JSX.Element {
  return (
    <LogoBox>
      <XSLogo style={{ height: '23px' }} />
    </LogoBox>
  );
}
